/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Modules_Go_OwnershipInputs */

const cs_clients_modules_go_ownership = /** @type {(inputs: Clients_Modules_Go_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít záložku vlastnictví`)
};

const en_clients_modules_go_ownership = /** @type {(inputs: Clients_Modules_Go_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open ownership tab`)
};

/**
* | output |
* | --- |
* | "Open ownership tab" |
*
* @param {Clients_Modules_Go_OwnershipInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_modules_go_ownership = /** @type {((inputs?: Clients_Modules_Go_OwnershipInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Modules_Go_OwnershipInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_modules_go_ownership(inputs)
	return cs_clients_modules_go_ownership(inputs)
});